import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { EventCard } from "~/components/events/EventCard";
import { fetchMyEvents } from "~/lib/api";
import { queryKeys } from "~/lib/query-client";

/**
 * "Moje rezervace" at the top of the Events tab: the places the member holds, soonest
 * first. Renders nothing while there are none — the calendar below is the page, and an
 * empty strip over it would read as a loading failure.
 */
export function MyEventsStrip({
  userId,
  locale,
}: {
  userId: string;
  locale: string;
}) {
  const { t } = useTranslation();
  const { data } = useQuery({
    queryKey: queryKeys.myEvents(userId, locale),
    queryFn: ({ signal }) => fetchMyEvents(locale, signal),
  });

  if (!data || data.length === 0) return null;

  return (
    <Box
      data-testid="events.mine"
      sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}
    >
      <Typography variant="H3" sx={{ color: "text.primary" }}>
        {t("events.mine.heading")}
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "minmax(0, 1fr)",
            md: "repeat(auto-fill, minmax(280px, 1fr))",
          },
          gap: 1.5,
        }}
      >
        {data.map((event) => (
          <EventCard key={event.id} event={event} withDate />
        ))}
      </Box>
    </Box>
  );
}
